import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type DialogData = {
  title: string;
  json?: any;
  message?: [string] | string;
  button?: {
    label: string;
    action: () => void;
    icon?: string;
  }
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<ModalComponent>
  ) { }

  close() {
    this.dialogRef.close();
  }
}
